import React, { useRef, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Auth } from 'aws-amplify';
import {
    Button,
    Checkbox,
    Divider,
    FormGroup,
    FormControlLabel,
    Grid,
    TextField,
    Toolbar,
    Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TlmBreadcrumbs from '../Components/TlmBreadcrumbs.jsx';
import { host } from "../../data";
import Geocode from "react-geocode";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { countries } from "../../data";
import { isValidEmail } from '../../helpers/isValidEmail';
import { useTranslation } from 'react-i18next';

Geocode.setApiKey("AIzaSyDZxhyTnVftkwNDwT2dR8ygpsztsBBwrxs"); // https://www.npmjs.com/package/react-geocode

const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
    },
    textInput: {
        margin: theme.spacing(1),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    clickButtons: {
        marginLeft: theme.spacing(0),
    }
}));

export default function BranchSettingsPage({ orgInfo, branchInfo, resetBranchData }) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const [branchName, setBranchName] = useState({ name: '' });
    const branch_name = useRef("");
    const [branchAddress, setBranchAddress] = useState({ address: '' });
    const branch_address_line_1 = useRef("");
    const [branchPhone, setBranchPhone] = useState({ phone: '' });
    const branch_phone = useRef("");
    const [branchContactName, setBranchContactName] = useState({ name: '' });
    const branch_contact_name = useRef("");
    const [branchContactEmail, setBranchContactEmail] = useState({ email: '' });
    const branch_email = useRef("");
    const [branchCity, setBranchCity] = useState({ city: '' });
    const branch_city = useRef("");
    const [country, setCountry] = useState("");
    const [region, setRegion] = useState("");
    const [defCheck, setDefCheck] = useState(false);

    function isValidEnteredEmail(value) {
        if (value === "")
            return (true);

        if (isValidEmail(value))
            return (true);

        alert(t("youHaveEnteredAnInvalidEmail"));
        return (false);
    };

    function isValidPhoneNumber(value) {
        if (value === "")
            return (true);

        if ((/^\d{7,}$/).test(value.replace(/[\s()+\-\.]|ext/gi, ''))) {
            return (true);
        }

        alert(t("youHaveEnteredAnInvalidPhone"));
        return (false);
    }

    const handleCheck = (event) => {
        setDefCheck(event.target.checked);
    };

    React.useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(response => {
                try {
                    response.getSession((err, session) => {
                        if (err) {
                            console.log(err);
                            return;
                        }

                        console.log("Fetching org information...");

                        fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': session.getIdToken().jwtToken
                            }
                        }).then(response => response.json())
                            .then(data => {
                                setBranchName({ name: data.name });
                                setBranchAddress({ address: data.address })
                                setBranchPhone({ phone: data.contact_phone });
                                setBranchContactName({ name: data.contact_name });
                                setBranchContactEmail({ email: data.contact_email });
                                setBranchCity({ city: data.city });
                                setCountry(data.country);
                                setRegion(data.state);
                                if (data.default_branch) {
                                    setDefCheck(true);
                                }
                                else {
                                    setDefCheck(false);
                                }
                            });
                    });
                } catch (e) {
                    console.log(e);
                }
            })
    }, []);

    const handleChangeCountry = (event) => {
        setCountry(event.target.value);
    };

    const handleChangeRegion = (event) => {
        setRegion(event.target.value);
    };

    function validateForm() {
        var ret = 1;

        if (branch_name.current.value === "") {
            alert(t("nameInvalid"));
            ret = 0;
        }

        return ret;
    }

    const handleClick = async () => {
        if (isValidEnteredEmail(branch_email.current.value) && isValidPhoneNumber(branch_phone.current.value) && validateForm()) {
            try {
                let user = await Auth.currentAuthenticatedUser();
                user.getSession((err, session) => {
                    if (err) {
                        console.log(err);
                        return;
                    }

                    const sessionToken = session.getIdToken().jwtToken;

                    try {
                        // Get latitude & longitude from address
                        const targetBranch = branch_name.current.value;
                        var address = branch_address_line_1.current.value + ' ' + branch_city.current.value + ' ' + region + ' ' + country;
                        if (branch_address_line_1.current.value !== "") {
                            Geocode.fromAddress(address).then(
                                (response) => {
                                    const { lat, lng } = response.results[0].geometry.location;

                                    var isDef = 0;
                                    if (defCheck) {
                                        isDef = 1;
                                    }
                                    var body = JSON.stringify(
                                        {
                                            "Name": branch_name.current.value,
                                            "Address": branch_address_line_1.current.value,
                                            "Phone": branch_phone.current.value,
                                            "ContactName": branch_contact_name.current.value,
                                            "Email": branch_email.current.value,
                                            "Latitude": lat,
                                            "Longitude": lng,
                                            "Country": country,
                                            "City": branch_city.current.value,
                                            "State": region,
                                            "ParentId": orgInfo.orgId,
                                            "isDefault": isDef
                                        }
                                    );

                                    var requestOptions = {
                                        method: 'PUT',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': sessionToken
                                        },
                                        body: body
                                    };

                                    fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId, requestOptions)
                                        .then(async response => {
                                            return { body: await response.json(), status: response.status }
                                        })
                                        .then(data => {
                                            if (data.status === 200) {
                                                resetBranchData(targetBranch);
                                            }
                                            else {
                                                console.log(data);
                                                alert(data.body);
                                            }
                                        })
                                        .catch(error => {
                                            console.log(error);
                                        });
                                },
                                (error) => {
                                    console.log(error);
                                }
                            );
                        }
                        else {
                            var body = JSON.stringify(
                                {
                                    "Name": branch_name.current.value,
                                    "Address": "",
                                    "Phone": branch_phone.current.value,
                                    "ContactName": branch_contact_name.current.value,
                                    "Email": branch_email.current.value,
                                    "Latitude": 0,
                                    "Longitude": 0,
                                    "Country": country,
                                    "City": branch_city.current.value,
                                    "State": region,
                                    "ParentId": orgInfo.orgId,
                                    "User": user.attributes.email //user.signInUserSession.accessToken.jwtToken
                                }
                            );

                            var requestOptions = {
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': sessionToken
                                },
                                body: body
                            };

                            fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId, requestOptions)
                                .then(async response => {
                                    // TODO: BranchCreate - Handle a branch create failure below.
                                    return { body: await response.json(), status: response.status }
                                })
                                .then(data => {
                                    if (data.status === 200) {
                                        resetBranchData(targetBranch);
                                    }
                                    else {
                                        console.log(data);
                                        alert(data.body);
                                    }
                                })
                                .catch((error) => {
                                    console.log(error);
                                });
                        }
                    }
                    catch (err) {
                        console.log(err);
                    } finally {
                    }
                });
            } catch (e) {
                console.log(e);
            }
        }
    };

    return (
        <Grid container
            direction='column'
            justify='flex-start'
            alignItems='stretch'
            className={classes.content}>
            <Grid item xs>
                <Toolbar>
                    {branchInfo === null
                        ? <TlmBreadcrumbs edge='start'
                            orgInfo={orgInfo}
                            branchInfo={null}
                            site={null}
                            tank={null} />
                        : <TlmBreadcrumbs edge='start'
                            orgInfo={orgInfo}
                            branchInfo={branchInfo}
                            site={t("edit")}
                            tank={null} />}
                </Toolbar>
            </Grid>
            <Grid item xs><Divider /></Grid>
            <Grid item xs>
                <form>
                    <Typography>
                        {t("branchDetails")}
                    </Typography>
                    <FormGroup>
                        <TextField id='branch-name'
                            onChange={(e) => {
                                const regex = /^([ a-zA-Z0-9\-]){0,40}$/i;
                                if (regex.test(e.target.value)) {
                                    setBranchName({ name: e.target.value });
                                }
                            }}
                            value={branchName.name}
                            inputRef={branch_name}
                            label={t("branchName")}
                            variant='filled'
                            className={classes.textInput} />
                    </FormGroup>
                    <Typography>{t("location")}</Typography>
                    <FormGroup>
                        <TextField id='branch-address-line-1'
                            onChange={e => setBranchAddress({ address: e.target.value })}
                            value={branchAddress.address}
                            inputRef={branch_address_line_1}
                            label={t("addressLine")}
                            variant='filled'
                            className={classes.textInput} />
                        <TextField id='branch-city'
                            onChange={e => setBranchCity({ city: e.target.value })}
                            value={branchCity.city}
                            inputRef={branch_city}
                            label={t("city")}
                            variant='filled'
                            className={classes.textInput} />
                        <FormControl className={classes.formControl}>
                            <InputLabel id="country-select-label">{t("country")}</InputLabel>
                            <Select
                                labelId="country-select-label"
                                id="country-select"
                                value={country}
                                onChange={handleChangeCountry} >
                                {countries.map((country) => (
                                    <MenuItem
                                        value={country.countryName}
                                        key={country.countryShortCode}
                                    >
                                        {t(country.translationKey)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <InputLabel id="region-select-label">{t("stateProvinceRegion")}</InputLabel>
                            <Select
                                labelId="region-select-label"
                                id="region-select"
                                value={region}
                                onChange={handleChangeRegion}
                                disabled={!country} >
                                {country
                                    ? countries
                                        .find(({ countryName }) => countryName === country)
                                        .regions.map((region) => (
                                            <MenuItem value={region.name} key={region.shortCode}>
                                                {t(region.translationKey)}
                                            </MenuItem>
                                        )) : []}
                            </Select>
                        </FormControl>

                    </FormGroup>
                    <Typography>
                        {t("branchContact")}
                    </Typography>
                    <FormGroup>
                        <TextField id='branch-contact'
                            onChange={e => setBranchContactName({ name: e.target.value })}
                            value={branchContactName.name}
                            inputRef={branch_contact_name}
                            label={t("name")}
                            variant='filled'
                            className={classes.textInput} />
                        <TextField id='branch-phone'
                            onChange={e => setBranchPhone({ phone: e.target.value })}
                            value={branchPhone.phone}
                            inputRef={branch_phone}
                            label={t("phoneNumber")}
                            variant='filled'
                            className={classes.textInput} />
                        <TextField id='branch-email'
                            onChange={e => setBranchContactEmail({ email: e.target.value })}
                            value={branchContactEmail.email}
                            inputRef={branch_email}
                            label={t("email")}
                            variant='filled'
                            className={classes.textInput} />
                        <FormControlLabel control={
                            <Checkbox
                                className={classes.clickButtons}
                                checked={defCheck}
                                onChange={handleCheck}
                                name="defIndicator"
                                color="primary"
                            />
                        }
                            label={t("defaultBranch")}
                        />
                    </FormGroup>
                </form>
            </Grid>

            <Grid item xs>
                <Button variant='contained' color='primary' className={classes.clickButtons} onClick={handleClick}>
                    {t("save")}
                </Button>
                <Button className={classes.clickButtons} component={RouterLink} to='/'>
                    {t("cancel")}
                </Button>
            </Grid>
        </Grid>
    )
}
